import type { ReactNode } from 'react';

export const MetricCard = ({
  label,
  value,
  tone,
}: {
  label: string;
  value: ReactNode;
  tone?: 'positive' | 'negative' | 'warning';
}) => (
  <div className="detail-metric">
    <span>{label}</span>
    <strong className={tone}>{value}</strong>
  </div>
);
